// Wire values of portal-api's RequestSource enum. The API binds enums as numbers
// (no string converter registered), so these must stay in sync with RequestSource.cs.
export const REQUEST_SOURCE = {
  mainSearch: 1,
  organisationProfile: 2,
};
